// Motion for Data Lab-only UI effects. Shared chart animation is configured by
// the chart settings and theme.
export const MOTION_TOKENS = {
  fade: { duration: 160, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' },
  select: { duration: 220, easing: 'cubic-bezier(0.66, 0, 0.34, 1)' },
  drill: { duration: 300, easing: 'cubic-bezier(0.66, 0, 0.34, 1)' },
} as const;
